export default __webpack_public_path__ + "static/area-guide-112d406da8c39ee121524a4e5028f8d2.png";